let map;
let searchParams = {
  lat: 0,
  lng: 0,
  radius: 10,
  city: '',
};

// If an autocomplete-picked address resolves within this distance (km) of an
// existing location, treat it as "that's actually this dealer" and jump straight to it.
const NEARBY_MATCH_RADIUS_KM = 0.025; // 25 meters

// Guards performSearch() against out-of-order responses — see its use there.
let searchRequestToken = 0;

// Rough rendered height (px) of an open InfoWindow with our content — used to shift
// the map center up so the marker + InfoWindow sit together in the visible middle,
// instead of centering on the marker alone and running the InfoWindow off the top.
const INFOWINDOW_HEIGHT = 325;

window.initMaps = function () {
  
  const partnerLocatorBlock = document.querySelector('.er-locations');
  const partnersMap = document.querySelector('.er-locations__map');
  const partnerLocatorList = document.querySelector('.er-locations__list');
  const partnerLocatorToggleMap = document.querySelector(
    '#er-locations-toggle-map'
  );
  const partnerLocatorToggleList = document.querySelector(
    '#er-locations-toggle-list'
  );
  const partnerLocatorRadiusButtonsContainer = document.querySelector(
    '.er-locations__radius-buttons'
  )
  const partnerLocatorRadiusButtons = document.querySelectorAll(
    '.er-locations__radius-button'
  )
  const partnerLocatorInput = document.querySelector(
    '.er-locations__search-input'
  );
  const partnerLocatorGeolocate = document.querySelector(
    '.er-locations__geolocate'
  );
  const partnerLocatorResultCounter = document.querySelector(
    '.er-locations__results-count'
  );
  const partnerLocatorButton = document.querySelector('.er-locations__submit');
  
  if (partnersMap) {
    map = initMap(partnersMap);
  }

  if (partnerLocatorInput) {
    initPartnerLocator(partnerLocatorInput, map);

    if (partnerLocatorInput && partnerLocatorInput.value.trim() !== '') {
      const geocoder = new google.maps.Geocoder();
      document.body.classList.add('autocomplete-suppress');
      geocoder.geocode({ address: partnerLocatorInput.value }, (results, status) => {
        if (status === 'OK' && results[0]) {
          const lat = results[0].geometry.location.lat();
          const lng = results[0].geometry.location.lng();
          searchParams.lat = lat;
          searchParams.lng = lng;

          checkSubmitButtonEnable();
          if (map) map.setCenter({ lat, lng });
          partnerLocatorButton.click();
        }
      });
    }
  }

  if (partnerLocatorToggleMap) {
    partnerLocatorToggleMap.addEventListener('click', () => {
      partnerLocatorToggleMap.classList.add('active');
      partnerLocatorToggleList.classList.remove('active');
      partnerLocatorBlock.dataset.mode = 'map';
    });
  }

  if (partnerLocatorToggleList) {
    partnerLocatorToggleList.addEventListener('click', () => {
      partnerLocatorToggleList.classList.add('active');
      partnerLocatorToggleMap.classList.remove('active');      
      partnerLocatorBlock.dataset.mode = 'list';
    });
  }

  if (partnerLocatorRadiusButtons) {
    partnerLocatorRadiusButtons.forEach((button) => {
      button.addEventListener('click', () => {
        partnerLocatorRadiusButtons.forEach((btn) => { 
          btn.classList.remove('active');
        })
        button.classList.add('active');
        searchParams.radius = parseInt(button.dataset.radius);
        checkSubmitButtonEnable();

        if (searchParams.lat && searchParams.lng) {
          performSearch(map);
        }
      });
    });
  }    

  const geolocateOptions = {
    maximumAge: 60000,
    timeout: 5000,
    enableHighAccuracy: true,
  };

  if (partnerLocatorGeolocate) {
    partnerLocatorGeolocate.addEventListener('click', () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            //You have your locaton here
            map.setCenter({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            });

            searchParams.lat = pos.coords.latitude;
            searchParams.lng = pos.coords.longitude;

            checkSubmitButtonEnable();

            // Refresh the map/list against the active radius right away, same as
            // picking an autocomplete suggestion now does, instead of requiring a
            // separate manual "Search" click.
            performSearch(map);

            const geocoder = new google.maps.Geocoder();
            const latlng = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            };
            geocoder.geocode({ location: latlng }, (results, status) => {
              if (status === 'OK') {
                if (results[0]) {
                  partnerLocatorInput.value = results[0].formatted_address;
                } else {
                  console.log('No results found');
                }
              } else {
                console.log('Geocoder failed due to: ' + status);
              }
            });
          },
          function (error) {
            console.log('Geolocate error!', error.code, error.message);
          },
          geolocateOptions
        );
      } else {
        console.log('Geolocation is not supported by this browser.');
      }
    });
  }

  function checkSubmitButtonEnable() {
    if(searchParams.lat && searchParams.lng && searchParams.radius) {
      partnerLocatorButton.disabled = false;
    } else {
      partnerLocatorButton.disabled = true;
    }
  }

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  function initPartnerLocator(input, map) {
    if (input) {
      
      input.addEventListener('focus', () => {
        document.body.classList.remove('autocomplete-suppress');
      });

      const options = {
        componentRestrictions: { country: ['be', 'de'] },
        strictBounds: false,
      };
      
      const autocomplete = new google.maps.places.Autocomplete(input, options);
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();

        // No geometry means the user hit Enter without picking a suggestion from the dropdown.
        if (!place.geometry || !place.geometry.location) {
          return;
        }

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        searchParams.lat = lat;
        searchParams.lng = lng;

        // Vendor/business results often lack a 'locality' component (or don't list it first),
        // unlike ZIP/city results — fall back gracefully instead of throwing.
        const addressComponents = place.address_components || [];
        const localityComponent =
          addressComponents.find((component) => component.types.includes('locality')) ||
          addressComponents.find((component) => component.types.includes('postal_town')) ||
          addressComponents.find((component) => component.types.includes('administrative_area_level_2'));
        searchParams.city = localityComponent ? localityComponent.long_name : '';

        checkSubmitButtonEnable();

        map.setCenter({
          lat: lat,
          lng: lng,
        });

        // Only treat this as "the user pinpointed one dealer" when the pick was a
        // business/POI result or a precise street-number address — a bare city or
        // postal code is too coarse and can coincidentally land within the match
        // radius of some unrelated dealer, wrongly hiding the full results list.
        const isBusinessResult = (place.types || []).includes('establishment');
        const hasStreetNumber = addressComponents.some((component) => component.types.includes('street_number'));
        const isPreciseMatch = isBusinessResult || hasStreetNumber;

        // Run the real search now (using the geocoded point) instead of waiting on a
        // manual submit click; for a precise match, performSearch() will focus the
        // nearest dealer instead of the usual fit-all-results view.
        performSearch(map, { focusNearest: isPreciseMatch });

      });
    }

    if (partnerLocatorButton) {
      partnerLocatorButton.addEventListener('click', () => {
        google.maps.event.trigger(input, 'focus', {});
        performSearch(map);
      });
    }
  }

  function performSearch(map, options = {}) {
    // Several triggers can call this in close succession (the page-load prefilled
    // search, an interactive autocomplete pick, radius buttons, geolocate) with no
    // guaranteed response order. Without this guard, a slower/earlier request's
    // response can land after a newer one and clobber the list/markers/map view
    // with stale data — apply a response only if no newer search has started since.
    const requestToken = ++searchRequestToken;

    partnerLocatorBlock.classList.remove('er-locations--init');
    partnerLocatorBlock.classList.add('er-locations--loading');

    partnerLocatorList.innerHTML = '';
    let listHtml = '';

    // Prepare data for POST
    const formData = new FormData();
    formData.append('action', 'search_locations');
    formData.append('nonce', locationSearchAjax.nonce); // nonce localized from PHP
    formData.append('lat', searchParams.lat);
    formData.append('lng', searchParams.lng);
    formData.append('radius', searchParams.radius);
    formData.append('city', searchParams.city);

    // Send AJAX request
    fetch(locationSearchAjax.ajax_url, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(data => {
      // A newer performSearch() call has since started — this response is stale,
      // discard it rather than clobbering whatever that newer search has already
      // rendered (or is about to).
      if (requestToken !== searchRequestToken) {
        return;
      }

      if (data.success) {
        // '.er-locations--loading' hides .er-locations__map/__list/__empty via CSS
        // (display:none !important) while the map's container is 0×0, fitBounds()/
        // setZoom() below compute a garbage zoom against that zero-size viewport.
        // Reveal the map before touching it, instead of on the old fixed 2s timer
        // (which fired well after the 100ms marker-refresh below already ran).
        partnerLocatorBlock.classList.remove('er-locations--loading');

        // data.data is the array of locations
        if(data.data.length) {
          data.data.forEach((location) => {
            listHtml += `
              <div class="er-locations__item"
              data-title="${location.title}"
              data-street="${location.street}"
              data-street="${location.postcode}"
              data-street="${location.city}"
              data-lat="${location.lat}"
              data-lng="${location.lng}"
              data-phone="${location.phone}"
              data-website="${location.website}"
              >
                ${buildLocationCardHtml(location)}
              </div>
            `;
          });
          partnerLocatorList.innerHTML = listHtml;
          setTimeout(() => {
            // Re-check: a newer search could have started during this delay.
            if (requestToken !== searchRequestToken) {
              return;
            }

            refreshMarkers(map);

            const nearest = data.data[0];
            const nearestLat = parseFloat(nearest.lat);
            const nearestLng = parseFloat(nearest.lng);
            // City-fallback entries (no coordinates yet) report distance 0 — not a real proximity match.
            const isCloseMatch =
              options.focusNearest &&
              (nearestLat || nearestLng) &&
              parseFloat(nearest.distance) <= NEARBY_MATCH_RADIUS_KM;

            if (isCloseMatch) {
              focusNearbyLocation(nearest);
            } else {
              centerMap(map);
            }
          }, 100);
          //showPartnersWithinRadius(searchParams.lat, searchParams.lng, searchParams.radius);
          partnerLocatorBlock.classList.remove('er-locations--empty');
        } else {
          partnerLocatorBlock.classList.add('er-locations--empty');
          partnerLocatorList.innerHTML = listHtml;
        }

        partnerLocatorResultCounter.innerHTML = data.data.length;

        // Render your map markers here
      } else {
        alert('Location search error');
      }
    })
    .catch(error => {
      console.error('AJAX error:', error);
      alert('AJAX error');
    });
  }

  // Centers the map on a point with a vertical offset, so a marker + its open
  // InfoWindow (which extends upward from the marker) land together in the middle
  // of the visible map instead of the marker sitting dead-center and the
  // InfoWindow's top edge running off-screen or crowding the map controls.
  function centerMapForInfoWindow(map, lat, lng) {
    const projection = map.getProjection();

    // Projection isn't available until the map has rendered at least once —
    // fall back to a plain center rather than throwing.
    if (!projection) {
      map.setCenter({ lat, lng });
      return;
    }

    const scale = Math.pow(2, map.getZoom());
    const worldPoint = projection.fromLatLngToPoint(new google.maps.LatLng(lat, lng));
    const offsetWorldPoint = new google.maps.Point(
      worldPoint.x,
      worldPoint.y - (INFOWINDOW_HEIGHT / 2) / scale
    );

    map.setCenter(projection.fromPointToLatLng(offsetWorldPoint));
  }

  // Focuses a single location on the map: centers tightly on it and opens its
  // InfoWindow, reusing the marker a just-refreshed list already rendered for it
  // (or building a standalone one if none exists).
  function focusNearbyLocation(location) {
    const lat = parseFloat(location.lat);
    const lng = parseFloat(location.lng);

    if (!lat && !lng) {
      return;
    }

    if (map.activeInfoWindow) {
      map.activeInfoWindow.close();
      map.activeInfoWindow = null;
    }

    map.setZoom(16);
    centerMapForInfoWindow(map, lat, lng);

    // Reuse the marker if a prior search already rendered this location on the map.
    const posMatchTolerance = 0.00001; // ~1m
    let marker = map.markers.find((m) => {
      return (
        Math.abs(m.position.lat() - lat) < posMatchTolerance &&
        Math.abs(m.position.lng() - lng) < posMatchTolerance
      );
    });

    if (!marker) {
      marker = createLocationMarker(map, {
        lat: lat,
        lng: lng,
        content: buildLocationCardHtml(location),
      });
      map.markers.push(marker);
    }

    if (marker.infowindow) {
      marker.infowindow.open(map, marker);
      map.activeInfoWindow = marker.infowindow;
    }
  }

  function buildLocationCardHtml(location) {
    return `
      <div class="er-locations__item-icon"></div>
      <div class="er-locations__item-content">
        <h4 class="er-locations__item-title">${location.title}</h4>
        <p class="er-locations__item-address">${location.street}<br>${location.postcode}<br>${location.city}</p>
        <div class="er-locations__item-contact">` +
          (location.phone ? `<a class="er-locations__item-phone" href="tel:${location.phone}">${location.phone}</a>` : '' ) +
          (location.website ? `<a class="er-locations__item-website" href="${location.website}" target="_blank">${location.website}</a>` : '') +
        `</div>
      </div>
    `;
  }

  function initMap(el) {
    let locations = document.querySelectorAll('.er-locations__item');

    let mapArgs = {
      zoom: 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    let map = new google.maps.Map(el, mapArgs);

    map.markers = [];
    map.activeInfoWindow = null;

    return map;
  }

  function refreshMarkers(map) {
    let locations = document.querySelectorAll('.er-locations__item');

    if (map.activeInfoWindow) {
      map.activeInfoWindow.close();
      map.activeInfoWindow = null;
    }

    // remove all markers from map
    for (let i = 0; i < map.markers.length; i++) {
      map.markers[i].setMap(null);
    }
    map.markers = [];

    locations.forEach((location) => {
      initMarker(location, map);
    });
  }

  function initMarker(markerEl, map) {
    var lat = parseFloat(markerEl.getAttribute('data-lat'));
    var lng = parseFloat(markerEl.getAttribute('data-lng'));

    // Ungeocoded city-fallback results come back with lat/lng 0 — skip them.
    if (!lat || !lng) {
      return;
    }

    // var bounds = {
    //   north: 56,   // Germany’s northernmost latitude
    //   south: 45,   // Belgium’s southernmost latitude
    //   east: 17,    // Germany’s easternmost longitude
    //   west: 1      // Belgium’s westernmost longitude
    // };

    // if (
    //   parseFloat(lat) < bounds.south ||
    //   parseFloat(lat) > bounds.north ||
    //   parseFloat(lng) < bounds.west ||
    //   parseFloat(lng) > bounds.east
    // ) {
    //   return;
    // }

    var marker = createLocationMarker(map, {
      lat: lat,
      lng: lng,
      content: markerEl.innerHTML,
      partnerId: markerEl.dataset.partnerId,
    });

    map.markers.push(marker);
  }

  // Builds a marker (and, when content is given, its InfoWindow + click wiring)
  // for a single location. Shared by the search-results list markers and by
  // the standalone nearby-match marker, which has no list item behind it.
  function createLocationMarker(map, { lat, lng, content, partnerId }) {
    const icon = {
      url: '/wp-content/themes/hello-theme-child-optimized/dist/icons/google_maps_pin.svg',
      scaledSize: new google.maps.Size(30, 30), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(0, 0), // anchor
    };

    // const iconActive = {
    //   url: '/wp-content/themes/enerix/icons/map-pin-active.png',
    //   scaledSize: new google.maps.Size(20, 20), // scaled size
    //   origin: new google.maps.Point(0, 0), // origin
    //   anchor: new google.maps.Point(0, 0), // anchor
    // };

    var marker = new google.maps.Marker({
      partnerId: partnerId,
      position: { lat: lat, lng: lng },
      map: map,
      content: content,
      icon: icon,
    });

    if (content) {
      var infowindow = new google.maps.InfoWindow({
        partnerId: partnerId,
        content: content,
        maxWidth: 400,
      });

      marker.infowindow = infowindow;

      google.maps.event.addListener(marker, 'click', function () {
        if (map.activeInfoWindow && map.activeInfoWindow !== infowindow) {
          map.activeInfoWindow.close();
        }
        infowindow.open(map, marker);
        map.activeInfoWindow = infowindow;
        centerMapForInfoWindow(map, lat, lng);
        //marker.setIcon(iconActive);
      });

      google.maps.event.addListener(infowindow, 'closeclick', function () {
        if (map.activeInfoWindow === infowindow) {
          map.activeInfoWindow = null;
        }
        //marker.setIcon(icon);
      });
    }

    return marker;
  }

  // function centerOnPartner(map, partnerId) {
  //     let iconCenterActive = {
  //         url: '/wp-content/themes/enerix/icons/map-pin-active.png',
  //         scaledSize: new google.maps.Size(20, 20), // scaled size
  //         origin: new google.maps.Point(0, 0), // origin
  //         anchor: new google.maps.Point(0, 0) // anchor
  //     };

  //     map.markers.forEach(function (marker) {
  //         if (marker.partnerId == partnerId) {
  //             marker.setIcon(iconCenterActive);
  //             map.setCenter(marker.position);
  //             map.setZoom(12);
  //             marker.infowindow.open(map, marker);
  //         }
  //     });
  // }

  // Zoom level whose visible height (at the map's actual pixel height) spans
  // roughly `diameterMeters` at the given latitude, per the standard Web Mercator
  // resolution formula (meters/pixel = 156543.03392 * cos(lat) / 2^zoom).
  function computeZoomForDiameter(map, lat, diameterMeters) {
    const mapHeightPx = map.getDiv().offsetHeight || 350;
    const metersPerPixel = diameterMeters / mapHeightPx;
    return Math.log2((156543.03392 * Math.cos((lat * Math.PI) / 180)) / metersPerPixel);
  }

  function centerMap(map) {
    if (!map.markers.length) {
      // No results to fit bounds to — show a consistent ~20km-wide view around the
      // searched point instead of leaving the map at whatever zoom/center a
      // previous search (or a focused marker) left behind.
      if (searchParams.lat && searchParams.lng) {
        map.setCenter({ lat: searchParams.lat, lng: searchParams.lng });
        map.setZoom(Math.round(computeZoomForDiameter(map, searchParams.lat, 20000)));
      }
      return;
    }

    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    if (map.markers.length == 1) {
      map.setZoom(15); // set a default zoom for single marker
      map.setCenter(bounds.getCenter());
    } else {
      map.fitBounds(bounds, 50); // add padding

      // Limit max zoom-out after fitBounds. Uses 'idle' (fires once the fitBounds
      // pan/zoom has actually settled) rather than 'bounds_changed' (which can fire
      // early with a transitional/stale zoom mid-animation and get overridden here
      // before fitBounds finishes settling on the correct, tighter zoom).
      google.maps.event.addListenerOnce(map, 'idle', function () {
        const MIN_ZOOM = 9;
        if (map.getZoom() < MIN_ZOOM) {
          map.setZoom(MIN_ZOOM);
        }
      });
    }
  }
};
